import { Link } from "react-router-dom";

const LOGO_URL = "https://static.readdy.ai/image/ca9cac5a446d046780455544702b2fd6/8a4e7eea10d3bf25b57da0f4bc4bea03.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-white pt-20 pb-8 px-8 rounded-t-3xl">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 pb-16 border-b border-stone-700">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src={LOGO_URL}
              alt="Havinar Homes"
              className="h-12 w-auto object-contain mb-6 brightness-200"
            />
            <p className="text-stone-400 text-sm leading-relaxed mb-8 max-w-xs">
              Havinar Homes elevates properties and exceeds expectations. Premium residential redevelopment and new construction delivering exceptional results.
            </p>
            <div className="flex gap-4">
              {[
                { icon: "ri-instagram-line", href: "#" },
                { icon: "ri-facebook-line", href: "#" },
                { icon: "ri-linkedin-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  rel="nofollow"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-700 text-stone-400 hover:border-amber-600 hover:text-amber-500 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-stone-500 mb-6">
              <a href="#navigation">Navigation</a>
            </h4>
            <ul className="flex flex-col gap-4">
              {[
                { label: "Home", href: "/" },
                { label: "About Us", href: "/about" },
                { label: "Contact Us", href: "/contact" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-stone-300 text-sm hover:text-amber-500 transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-stone-500 mb-6">
              <a href="#contact-info">Contact</a>
            </h4>
            <ul className="flex flex-col gap-4 text-sm text-stone-300">
              <li className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5"><i className="ri-mail-line text-amber-500" /></span>
                <a href="mailto:info@havinar.com" className="hover:text-amber-500 transition-colors">info@havinar.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-stone-500">
          <p>&copy; {currentYear} Havinar Homes. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="hover:text-amber-500 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" rel="nofollow" className="hover:text-amber-500 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
